import React, { Component, Fragment } from 'react';
import { CloseOutlined, PlusCircleOutlined, UploadOutlined } from '@ant-design/icons';
import { Spin, Upload } from 'antd';
import VirtualTable from '@/components/VirtualTable';
import { numberCheck } from "@/services/helper/dataProcess";
import { CURRENT_PWL_TABLE } from '../../../../services/Cascade/constants';
import { uploadPWLTableFile } from '../../../../services/Cascade/Impedance';
import '../index.css';

const CurrentColumns = [
  {
    title: 'Index',
    dataIndex: 'index',
    width: '16%'
  },
  {
    title: 'Time (ns)',
    dataIndex: 'time',
    width: '42%'
  }, {
    title: 'Current (A)',
    dataIndex: 'current',
    width: '42%'
  }
]

const SETTINGS = {
  minIndex: 0,
  startIndex: 0,
  itemHeight: 40,
  amount: 50,
  tolerance: 10
}

class PWLTable extends Component {

  constructor(props) {
    super(props);
    this.state = {
      currentPoints: [],
      loading: false,
      updateDataStatus: false,
      error: null
    };
  }

  componentDidMount = () => {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
    this.initColumns();
    this.initState();
  }

  initState = () => {
    const { dieCurrent, maxStopTime } = this.props;
    const currentPoints = dieCurrent && dieCurrent.currentPoints ? dieCurrent.currentPoints : []
    const calcStopTime = currentPoints.length > 0 ? currentPoints[currentPoints.length - 1].time : '0';
    const defaultStopTime = Number(calcStopTime) > maxStopTime ? calcStopTime : maxStopTime
    const isCurrentType = dieCurrent && dieCurrent.currentType && dieCurrent.currentType === CURRENT_PWL_TABLE
    this.setState({
      error: null,
      currentPoints: currentPoints.map((item, index) => ({
        time: item.time,
        current: item.current,
        index
      })),
      stepTime: (dieCurrent && dieCurrent.stepTime && isCurrentType) ? dieCurrent.stepTime : '10',
      stopTime: (dieCurrent && dieCurrent.stopTime && isCurrentType) ? dieCurrent.stopTime : defaultStopTime,
      startTime: (dieCurrent && dieCurrent.startTime && isCurrentType) ? dieCurrent.startTime : '0',
      loading: true
    }, () => {
      this.props.savePoints(this.getCurrentPoints());
      this.setState({
        loading: false,
        updateDataStatus: !this.state.updateDataStatus
      })
    })
  }

  initColumns = () => {
    CurrentColumns[0].render = (text) => {
      return <span>{Number(text) + 1}</span>
    }

    CurrentColumns[1].onCell = (record) => {
      return {
        record,
        edit: true,
        dataIndex: 'time',
        handleSave: (row) => this.saveValue(row, 'time')
      }
    }

    CurrentColumns[2].render = (text, record) => {
      return (
        <div>
          <span>{text}</span>
          <CloseOutlined
            className="imp-current-delete-icon"
            onClick={(e) => this.deleteRow(e, record)} />
        </div>
      );
    }

    CurrentColumns[2].onCell = (record) => {
      return {
        record,
        edit: true,
        dataIndex: 'current',
        handleSave: (row) => this.saveValue(row, 'current')
      }
    }
  }

  updateStopTime = (newPoints) => {
    const { maxStopTime } = this.props
    const defaultStopTime = newPoints.length > 0 ? newPoints[newPoints.length - 1].time : null
    if (Number(defaultStopTime) > maxStopTime) {
      this.setState({
        stopTime: defaultStopTime
      })
    }
  }

  saveValue = (row, key) => {
    const currentIndex = row.index;
    const value = row[key];
    const { currentPoints } = this.state;
    let _points = JSON.parse(JSON.stringify(currentPoints))
    _points.find(point => point.index === currentIndex)[key] = value;
    this.updateStopTime(_points)
    this.setState({
      currentPoints: _points,
      updateDataStatus: !this.state.updateDataStatus
    }, () => { this.props.refreshPlot() })
  }

  addTableRow = (e) => {
    const { currentPoints } = this.state;
    let newIndex = currentPoints.length ? currentPoints[currentPoints.length - 1].index + 1 : 0;
    const newPoints = [...currentPoints, { time: '', current: '', index: newIndex }]
    this.updateStopTime(newPoints)
    this.setState({
      currentPoints: newPoints,
    }, () => { this.props.refreshPlot() })
  }

  deleteRow = (e, record) => {
    e.stopPropagation();
    const { index } = record;
    const { currentPoints } = this.state;
    let newPoints = currentPoints.filter(point => point.index !== index).map((point, index) => { return { ...point, index } });
    this.updateStopTime(newPoints)
    this.setState({
      currentPoints: newPoints,
    }, () => { this.props.refreshPlot() })
  }

  saveCurrent = (closePanel) => {
    const { stepTime, stopTime, startTime } = this.state;
    let newPoints = this.getCurrentPoints('Error');
    if (newPoints === 'Error') {
      return false;
    }
    const _dieCurrent = {
      currentPoints: [...newPoints],
      currentType: CURRENT_PWL_TABLE,
      stepTime,
      stopTime,
      startTime
    }
    this.props.updateCurrent(_dieCurrent, closePanel)
    return true;
  }

  getCurrentPoints = (errorReturn = []) => {
    const { currentPoints = [] } = this.state;
    let newPoints = [];
    let prevTime = null, prevIndex = -1;
    for (let i = 0; i < currentPoints.length; i++) {
      const point = currentPoints[i];
      const { time, current } = point;
      const checkArray = [{ msg: 'Time must be a number.', value: time }, { msg: 'Current must be a number.', value: current }]
      for (let check of checkArray) {
        let error = numberCheck(check.value);
        if (error) {
          errorReturn === 'Error' && this.setState({ error: check.msg });
          return errorReturn;
        }
      }
      if (prevTime !== null && Number(time) < Number(prevTime)) {
        errorReturn === 'Error' &&
          this.setState({
            error: `Time must be strictly increasing. Point ${i + 1} (time=${time}) is not greater than point ${prevIndex + 1} (time=${prevTime}).`
          });
        return errorReturn;
      }
      prevTime = time;
      prevIndex = i;
      newPoints.push({
        time,
        current
      });
    }
    return newPoints;
  }

  uploadFile = async (options) => {
    const { file } = options;
    this.setState({
      loading: true,
      error: null
    })
    try {
      const res = await uploadPWLTableFile({ file });
      if (!res) {
        this.setState({
          error: 'Upload file failed.',
          loading: false
        })
        return
      }
      const newPoints = res.map((item, index) => ({ ...item, index }));
      this.updateStopTime(newPoints);
      this.setState(prevState => ({
        currentPoints: newPoints,
        updateDataStatus: !prevState.updateDataStatus,
        loading: false,
      }), () => {
        this.props.refreshPlot();
      });
    } catch (error) {
      console.error(error);
      this.setState({
        error: `${error} Upload file failed.`,
        loading: false,
      });
    }
  };

  render() {
    const { error, currentPoints, loading, updateDataStatus } = this.state;
    const { panelHeight } = this.props
    const _height = Number(panelHeight.replace('px', ''))
    const titleHeight = error ? 198 : 124
    const height = _height - titleHeight > 0 ? _height - titleHeight : 312

    return (
      <Fragment>
        <div className='imp-current-pwl cascade-setup-border'>
          <Fragment>
            <span className='font-bold imp-current-value-span' >
              <span>PWL Current Table</span>
            </span>
            <PlusCircleOutlined
              title="Add table row"
              className='cascade-imp-icon'
              onClick={(e) => this.addTableRow(e)} />
            <Upload
              name='file'
              showUploadList={false}
              customRequest={this.uploadFile}
            >
              <UploadOutlined className='cascade-imp-icon' title="Upload a two column text file" />
            </Upload>
          </Fragment>
          <Spin spinning={loading} tip={'loading'}>
            <div className="imp-current-pwl-table">
              <VirtualTable
                rowKey={'index'}
                columns={CurrentColumns}
                pagination={false}
                dataSource={currentPoints}
                setting={{ ...SETTINGS, maxIndex: currentPoints.length }}
                height={height}
                bordered
                size="small"
                scrollId={`virtual-table-scroll-pwl`}
                updateDataStatus={updateDataStatus}
              />
            </div>
          </Spin>
        </div>
        {error && <span className='imp-current-name-error-msg'>{error}</span>}
      </Fragment>
    );
  }
}

export default PWLTable;